import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class ConfigureIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path fillRule="evenodd" d="M1.251 8.375a.2.2 0 0 1-.26-.07L.025 6.694a.186.186 0 0 1 .068-.253l.856-.506a.36.36 0 0 0 .162-.278V4.343a.366.366 0 0 0-.162-.279l-.857-.506a.184.184 0 0 1-.067-.253l.964-1.61a.201.201 0 0 1 .261-.07l.883.462a.39.39 0 0 0 .331-.005l1.18-.656a.363.363 0 0 0 .17-.274l.027-.968a.192.192 0 0 1 .193-.183L5.965 0c.104 0 .19.084.193.183l.027.968a.355.355 0 0 0 .17.274l1.18.657c.09.051.24.052.331.005l.883-.462a.2.2 0 0 1 .26.07l.965 1.611a.186.186 0 0 1-.068.253l-.856.506a.36.36 0 0 0-.162.278v1.314c0 .101.075.227.162.279l.857.506c.09.052.12.166.067.253l-.964 1.61a.201.201 0 0 1-.261.07l-.883-.462a.39.39 0 0 0-.331.005l-1.18.656a.363.363 0 0 0-.17.274l-.027.968a.192.192 0 0 1-.193.183L4.035 10a.194.194 0 0 1-.193-.183l-.027-.968a.355.355 0 0 0-.17-.274l-1.18-.657a.392.392 0 0 0-.331-.005l-.883.462zM3.861 6.9c1.09.607 2.482.247 3.11-.803.63-1.05.256-2.391-.833-2.997-1.088-.607-2.48-.247-3.11.803-.629 1.05-.255 2.391.834 2.997z"/></svg>
        )
    }
}

export default withCssClassName(ConfigureIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/configure-icon.js